import { useT } from '../i18n/context'
import { useThemeStore } from '../stores/theme'

/** Hell/Dunkel-Toggle (Mond = dunkel ist aktiv, Sonne = hell ist aktiv). */
export function ThemeToggle({ className = '' }: { className?: string }) {
    const t = useT()
    const theme = useThemeStore(s => s.theme)
    const toggle = useThemeStore(s => s.toggle)
    const isDark = theme === 'dark'

    return (
        <button
            type='button'
            onClick={toggle}
            aria-label={isDark ? t('theme.toLight') : t('theme.toDark')}
            title={isDark ? t('theme.toLight') : t('theme.toDark')}
            aria-pressed={isDark}
            className={`flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 dark:text-slate-400 transition-colors hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-700 ${className}`}
        >
            {isDark ? (
                // Sonne
                <svg
                    className='h-4 w-4'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    strokeWidth={2}
                    aria-hidden='true'
                >
                    <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M12 3v2m0 14v2m9-9h-2M5 12H3m15.364 6.364l-1.414-1.414M7.05 7.05L5.636 5.636m12.728 0l-1.414 1.414M7.05 16.95l-1.414 1.414M16 12a4 4 0 11-8 0 4 4 0 018 0z'
                    />
                </svg>
            ) : (
                // Mond
                <svg
                    className='h-4 w-4'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    strokeWidth={2}
                    aria-hidden='true'
                >
                    <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
                    />
                </svg>
            )}
        </button>
    )
}
